export default {"src":"/_next/static/media/tiktak.e2149f0e.gif","height":524,"width":655,"blurWidth":0,"blurHeight":0};